import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import {
  Col,
  Label,
  languageOptions,
  Row,
  Select,
} from '@folio/stripes-components';
import { useIntl } from 'react-intl';
import { required } from '../../../utils/utils';
import HelpeModal from '../../HelpeModal';
import css from '../styles.css';

const propTypes = {
  fieldValues: PropTypes.object,
  index: PropTypes.number,
  fieldName: PropTypes.string,
  parentField: PropTypes.object,
  showHelpeIcon: PropTypes.bool,
};

function LanguageFieldComponent({
  fieldValues,
  index,
  fieldName,
  parentField,
  showHelpeIcon,
}) {
  const {
    name,
    label,
    type,
    isRequired,
    canEdit,
    isRepeatable,
    dataOptionsLimits,
    defaultValue,
    helpeText,
  } = fieldValues;

  const intl = useIntl();
  const fieldLabel = label.find((field) => field.locale === intl.locale)?.value;
  const langOptions = languageOptions(intl);

  const defaultValueFormatter = () => {
    const defaultData = dataOptionsLimits?.length
      ? dataOptionsLimits
      : langOptions;

    return defaultData;
  };

  const handleFieldLabelAppeerance = () => {
    if (isRepeatable || (parentField?.type === 'fieldArray' && index !== 0)) {
      return null;
    }
    return <Label fullWidth>{fieldLabel}</Label>;
  };

  const containerCondition =
    parentField?.type !== 'fieldArray' && !isRepeatable;

  return (
    <Row className={containerCondition ? css.container : ''}>
      <Col xs={showHelpeIcon ? 11 : 12}>
        <Field
          id={`inventory-templates-form-generator-${type}-field-${index}`}
          component={Select}
          fullWidth
          name={fieldName}
          subscription={{ value: true }}
          label={handleFieldLabelAppeerance()}
          dataOptions={[
            {
              label: intl.formatMessage(
                {
                  id: 'ui-plugin-inventory-templates.formGenerator.selectField.chooseMsg',
                  defaultMessage: 'Choose {fieldLabel}',
                },
                { fieldLabel },
              ),
              value: '',
            },
            ...defaultValueFormatter(),
          ]}
          // defaultValue={isRepeatable ? '' : defaultValue}
          // defaultValue={defaultValue}
          parse={(value) => (value === '' ? null : value)} // Fix issue: Empty values don't appear in values
          required={isRequired}
          validate={isRequired ? required : () => undefined}
          type="text"
          disabled={!canEdit}
        />
      </Col>
      {showHelpeIcon && (
        <Col xs={1} className={css.margin_btn}>
          <HelpeModal
            fieldData={fieldValues}
            title={fieldLabel}
            iconSize="medium"
          />
        </Col>
      )}
    </Row>
  );
}

LanguageFieldComponent.propTypes = propTypes;

export default LanguageFieldComponent;
